import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'


const joinStrings = (strings, separator, lastSeparator) => {
  if (strings.length === 0) return ''
  if (strings.length === 1) return strings[0]

  const data = [...strings]
  const last = data.pop()
  data[data.length - 1] += lastSeparator + last

  return data.join(separator)
}

export const useActiveUnavailableStatusesString = (localizedUnavailableStatuses) => {
  const [{ value: unavailableStatuses }] = useFormField('unavailableStatuses')

  const statuses = localizedUnavailableStatuses
    .filter(({ id }) => unavailableStatuses.includes(id))
    .map(({ name }) => name.toLowerCase())

  return joinStrings(statuses, ', ', ` ${I18n.t('publisher.enforcement.or')} `)
}
